import { ArrowDownBoxIcon } from './ArrowDownBoxIcon';

/**
 * author: Austin Andrews
 * id 04449961-F211-4FB7-BD87-EDA5F828B41D
 * name arrow-down-box
 * version: 1.8.36
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-down-box.svg
 * tags
 * - Arrow 
 */
export const ArrowBottomBoxIcon = ArrowDownBoxIcon;
export default ArrowBottomBoxIcon